/**
 * AEM model values may arrive as boolean or string.
 * Returns true when the value is strictly false or the string 'false'.
 */
export const isFlagFalse = (value: unknown): boolean => value === false || value === 'false';

/**
 * AEM model values may arrive as boolean or string.
 * Returns true when the value is strictly true or the string 'true'.
 */
export const isFlagTrue = (value: unknown): boolean => value === true || value === 'true';
